import add from '../../img/add.png'
import del from '../../img/delete.png';
import edit2 from '../../img/edit2.png'


function componentOpen(src, isAdd) {
  return (<div className={isAdd ? 'profile_add-button' : 'profile_edit-open'}><img src={src} alt="utils"/></div>)
}
function componentOpenAdd() {
  return componentOpen(add, true)
}

function componentOpenEdit() {
  return componentOpen(edit2, false)
}

function componentOpenDelete() {
  return componentOpen(del, false)
}

function generateRandomPassword() {
  const min = 10000;
  const max = 999999;
  return Math.floor(Math.random() * (max - min + 1)) + min;
}


export {generateRandomPassword, componentOpenAdd, componentOpenEdit, componentOpenDelete}